import { QuoteDTO } from 'models/quote';
import { TrimAtColumnRender } from 'components/base-components/DataTableV2';

export default function jobTitleTemplate({ jobTitle, comments }: QuoteDTO) {
  const value = `${jobTitle} - ${comments}`;
  const trimAt = TrimAtColumnRender(55);
  return trimAt(value);
}
